export default __webpack_public_path__ + "static/picture-before-063f24b5fb43ba7cd148bda9fc03631f.webp";